// extracted by mini-css-extract-plugin
export default {"importVessels":"ImportVessels_importVessels__altph","outputTable":"ImportVessels_outputTable__0Iyyk"};